<!--個人基本資料-->
<div class="page-container">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">{{ 'reserve-info.title' | translate }}</h2>
    <p class="page-subtitle">{{ 'reserve-info.subtitle' | translate }}</p>
    <!-- <div class="page-subtitle-block">
      <img
        width="26"
        height="26"
        ngSrc="assets/img/i-clock-user.svg"
        alt="clock-user"
      />
      <p>{{ 'reserve-info.message' | translate }}</p>
    </div> -->
  </div>

  <!--個人基本資料-->
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="card-content register-card-content"
  >
    <h3 class="register-card-title">
      {{ 'reserve-info.basic-info' | translate }}
    </h3>
    <div class="input-block">
      <label class="input-title" for="gender">{{
        'reserve-info.gender' | translate
      }}</label>
      <mat-radio-group id="gender" formControlName="gender">
        <mat-radio-button [value]="API_PARAMS.GENDER.MALE"
          >{{ 'reserve-info.gender-male' | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="API_PARAMS.GENDER.FEMALE"
          >{{ 'reserve-info.gender-female' | translate }}
        </mat-radio-button>
      </mat-radio-group>
      @if (showError && form.get('gender')?.invalid) {
        <mat-error class="input-error-msg">{{
          'error.gender-error.required' | translate
        }}</mat-error>
      }
    </div>
    <div class="input-block">
      <label class="input-title" for="birthday">{{
        'reserve-info.birthday' | translate
      }}</label>
      <div class="input-calculator-block">
        <div class="input-group input-btn-right">
          <input
            id="birthday"
            appDateInput
            matInput
            [matDatepicker]="picker"
            [placeholder]="DATE_FORMAT"
            formControlName="birthday"
            [ngClass]="{
              'input-error':
                showError &&
                form.get('birthday')?.invalid &&
                !form.get('birthday')?.hasError('invalidAge'),
            }"
          />
          <mat-datepicker-toggle [for]="picker" class="input-date-btn">
            <ng-container matDatepickerToggleIcon>
              <img src="assets/img/i-calendar.svg" alt="" />
            </ng-container>
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <div
          class="input-calculator-msg"
          [ngClass]="{
            'input-none':
              showError && form.get('birthday')?.hasError('invalidAge'),
          }"
        >
          <span>{{
            'reserve-info.current-age' | translate: { age: age }
          }}</span>
        </div>
        <div class="input-group input-btn-right">
          @if (showError && form.get('birthday')?.invalid) {
            <mat-error class="input-error-msg">
              <span [innerHTML]="getBirthdayErrorMessage()"></span>
            </mat-error>
          }
        </div>
      </div>
    </div>

    <!--選擇女性：出現的選項-->
    @if (isFemale) {
      <div class="input-block">
        <label class="input-title" for="status">{{
          'reserve-info.are-you-in-following-status' | translate
        }}</label>
        <mat-radio-group id="status" formControlName="status">
          <mat-radio-button [value]="API_PARAMS.FEMALE_STATUS.PREGNANCY"
            >{{ 'reserve-info.pregnancy' | translate }}
          </mat-radio-button>
          <mat-radio-button
            [value]="API_PARAMS.FEMALE_STATUS.POSTPARTUM_BREASTFEEDING"
            >{{ 'reserve-info.postpartum-breastfeeding' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="API_PARAMS.FEMALE_STATUS.NONE"
            >{{ 'reserve-info.none-of-above' | translate }}
          </mat-radio-button>
        </mat-radio-group>
        @if (showError && form.get('status')?.invalid) {
          <mat-error class="input-error-msg">{{
            'error.female-status-error.required' | translate
          }}</mat-error>
        }
      </div>
      <div class="input-block">
        <label class="input-title" for="menopausal">{{
          'reserve-info.are-you-menopausal' | translate
        }}</label>
        <mat-radio-group id="menopausal" formControlName="menopausal">
          <mat-radio-button value="true">{{
            'common.radio-button.yes' | translate
          }}</mat-radio-button>
          <mat-radio-button value="false">{{
            'common.radio-button.no' | translate
          }}</mat-radio-button>
        </mat-radio-group>
        @if (showError && form.get('menopausal')?.invalid) {
          <mat-error class="input-error-msg">{{
            'error.female-menopausal-error.required' | translate
          }}</mat-error>
        }
      </div>
    }

    <!--固定按鈕區塊-->
    <div class="page-btn-block">
      <button mat-button type="submit" class="btn-fill-primary btn-size-l">
        {{ 'common.button.next' | translate }}
      </button>
    </div>
  </form>
</div>
